import { Configuration, PopupRequest } from '@azure/msal-browser';

// MSAL configuration — mirrors duo_hub's, which is proven fast and non-hanging in production.
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID || 'common'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
    protocolMode: 'AAD',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true, // required for ssoSilent to work reliably
    secureCookies: true,
  },
  system: {
    allowRedirectInIframe: false,
    allowNativeBroker: false,
    iframeHashTimeout: 2000,
    loadFrameTimeout: 2000,
    navigateFrameWait: 300,
  },
};

export const loginRequest: PopupRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
  // No prompt parameter — allows automatic silent login if the user is already signed in.
};
